export const messages = {
  en: {
    listOweFee: {
      search: {
        title: 'Search Conditions',
        floorName: 'Please select building',
        unit: 'Please select unit',
        roomNum: 'Please enter room number',
        roomType: 'Please select room type',
        ownerName: 'Please enter owner name',
        payObjType: 'Please select payment object type',
        roomNumFormat: 'Please enter room number, e.g. 1-1-1123',
        carportNum: 'Please enter parking space number, e.g. 6-8',
        feeConfig: 'Please select fee items',
        overdueMonths: 'Overdue Months',
        reminderState: 'Reminder Status'
      },
      table: {
        title: 'Arrears Information',
        index: 'No.',
        payerObjName: 'Payment Object',
        ownerName: 'Owner Name',
        ownerTel: 'Phone Number',
        endTime: 'Start Time',
        deadlineTime: 'End Time',
        total: 'Total (Unit: Yuan)',
        updateTime: 'Update Time',
        reminderState: 'Reminder Status'
      },
      summary: {
        subtotal: 'Subtotal',
        total: 'Total',
        grandTotal: 'Grand Total'
      },
      exportSuccess: 'Export initiated successfully',
      exportError: 'Export failed',
      export: {
        confirmMessage: 'Are you sure you want to export {count} records?'
      },
      button: {
        collection: 'Send Collection Notice',
        detailedExport: 'Detailed Export'
      },
      collection: {
        confirmMessage: 'Are you sure you want to send collection notice? (Up to 300 notices can be sent at a time, cannot resend to the same phone number within 3 days)',
        success: 'Sending {count} collection notices, please check the results later',
        failed: 'Failed to send collection notice',
        error: 'Error sending collection notice',
        errorFailed: 'Failed to send collection notice'
      },
      reminderState: {
        W: 'Pending',
        C: 'Completed',
        F: 'Failed',
        D: 'Processing'
      }
    },
    searchFloor: {
      title: 'Building Selection',
      floorId: 'Please enter building ID',
      floorName: 'Please enter building name',
      floorNum: 'Please enter building number',
      table: {
        floorId: 'Building ID',
        floorName: 'Name',
        floorNum: 'Number',
        userName: 'Creator'
      }
    }
  },
  zh: {
    listOweFee: {
      search: {
        title: '查询条件',
        floorName: '请选择楼栋',
        unit: '单元',
        roomNum: '请填写房屋编号',
        roomType: '请选择房屋类型',
        ownerName: '请填写业主名称',
        payObjType: '请选择付费对象类型',
        roomNumFormat: '请填写房屋编号,如1-1-1123',
        carportNum: '请填写车位编号，如6-8',
        feeConfig: '请选择收费项',
        overdueMonths: '欠费超时',
        reminderState: '催缴状态'
      },
      table: {
        title: '欠费信息',
        index: '序号',
        payerObjName: '收费对象',
        ownerName: '业主名称',
        ownerTel: '手机号',
        endTime: '开始时间',
        deadlineTime: '结束时间',
        total: '合计 (单位：元)',
        updateTime: '更新时间',
        reminderState: '催缴状态'
      },
      summary: {
        subtotal: '小计',
        total: '合计',
        grandTotal: '总计'
      },
      exportSuccess: '导出成功',
      exportError: '导出失败',
      export: {
        confirmMessage: '是否确认导出 {count} 条信息？'
      },
      button: {
        collection: '催缴',
        detailedExport: '详细导出'
      },
      collection: {
        confirmMessage: '确定要发送催缴信息吗？(一次发送最多不超过300条，同一手机号发送成功后，三天内不能重复发送)',
        success: '正在发送 {count} 条催缴信息，请稍后查看发送结果',
        failed: '发送催缴信息失败',
        error: '发送催缴信息异常',
        errorFailed: '发送催缴信息失败'
      },
      reminderState: {
        W: '待催缴',
        C: '催缴完成',
        F: '催缴失败',
        D: '催缴中'
      }
    },
    searchFloor: {
      title: '小区楼栋',
      floorId: '请输入楼栋ID',
      floorName: '请输入楼栋名称',
      floorNum: '请输入楼栋编号',
      table: {
        floorId: '楼栋ID',
        floorName: '名称',
        floorNum: '编号',
        userName: '创建人'
      }
    }
  }
}